import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

// [2026-08-12] Recursos de IA precisam de MUITO mais que 30s.
// Desde que o sistema passou a usar a assinatura do Erivan (Claude Code) em vez da
// chave de API, as respostas levam de 25s a 3min: o CLI sobe uma sessao inteira antes
// de responder. O chat com edital voltava 'Nao foi possivel obter resposta' enquanto o
// servidor registrava status=200 em 29s — quem desistia era o navegador, nao a IA.
//
// Fica aqui, num interceptador, porque sao seis telas chamando /ia/ (chat, extrair
// edital, checklist, analise tecnica, decremento, login). Corrigir uma a uma deixaria
// as proximas com o mesmo defeito.
const PACIENCIA_IA = 300000;   // 5 min
api.interceptors.request.use((config) => {
  // ATENCAO: nao testar "!config.timeout" aqui. O axios ja mesclou o padrao da
  // instancia (30s) neste config, entao o campo NUNCA vem vazio — a condicao nunca
  // passava e o chat continuou desistindo aos 30s, com o nginx registrando 499.
  // Quem pediu um tempo maior na chamada mantem o dele; o resto ganha os 5 min.
  if ((config.url || '').includes('/ia/')) {
    config.timeout = Math.max(Number(config.timeout) || 0, PACIENCIA_IA);
  }
  return config;
});


// Adiciona token em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('licitapro_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redireciona para login em caso de 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('licitapro_token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
